import React, { useState } from "react";
import CreateTeamModal from "./CreateTeamModal";
import TeamCreatedModal from "./TeamCreatedModal";

export default function CreateTeamButton(props) {
  const [showCreateTeamModal, setShowCreateTeamModal] = useState(false);
  const [createdTeamSlug, setCreatedTeamSlug] = useState("");

  return (
    <>
      <button
        className="create-team-btn"
        onClick={() => setShowCreateTeamModal(true)}
      >
        Create team
      </button>
      {showCreateTeamModal && (
        <CreateTeamModal
          {...props}
          onClose={(slug = "") => {
            setShowCreateTeamModal(false);
            setCreatedTeamSlug(slug);
          }}
        />
      )}
      {createdTeamSlug && (
        <TeamCreatedModal
          onClose={() => setCreatedTeamSlug("")}
          slug={createdTeamSlug}
        />
      )}
    </>
  );
}
